/**
 * Creates an interactive color variable object with predefined CSS variable names.
 *
 * @template T - A string type that represents the base key for the interactive color variables.
 * @param key - The base key used to construct the CSS variable names.
 * @returns A frozen object of type `InteractiveColorVar<T>` containing CSS variable names for different states.
 *
 * Example:
 * ```typescript
 * const colorVars = createInteractiveColorVar('primary');
 * // Result:
 * // {
 * //   default: 'var(--primary-default)',
 * //   action: 'var(--primary-action)',
 * //   active: 'var(--primary-active)',
 * //   activeAction: 'var(--primary-active-action)',
 * // }
 * ```
 */
const createInteractiveColorVar = (key) => Object.freeze({
    default: `var(--${key}-default)`,
    action: `var(--${key}-action)`,
    active: `var(--${key}-active)`,
    activeAction: `var(--${key}-active-action)`,
});

export { createInteractiveColorVar };
